import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Services
import { AppConfigService } from '@core/services/app-config.service';

/**
 * Protège les routes privées — décision synchrone sur `appConfig.isLogged`, injecté par le JSP
 * à chaque chargement de page (login et logout provoquent tous deux un rechargement complet).
 */
export const authGuard: CanActivateFn = () => {
	const appConfig = inject(AppConfigService);
	const router = inject(Router);

	return appConfig.isLogged || router.createUrlTree(['login']);
};
